import { TFunction } from "i18next";

import { LeadPanelTabItem } from "@/pages/Private/pages/Contacts/components/LeadPanelTabs";

/** The lead panel's content tabs. Persisted in the URL as `detailTab`, so the values are stable. */
export enum DetailViewTab {
	OVERVIEW = "OVERVIEW",
	RESEARCH = "RESEARCH",
	TIMELINE = "TIMELINE",
	PROFILES = "PROFILES",
}

interface DetailViewTabsInput {
	t: TFunction;
	/**
	 * Deep Research is a paid feature; without it the tab is absent, not empty. Optional because
	 * `useIsFeatureActive` answers `undefined` until the company's features have loaded — and an
	 * unknown feature is not an active one.
	 */
	isDeepResearchActive?: boolean;
	researchCount: number;
	profilesCount: number;
}

/**
 * Build the panel's tab strip. Split out of `DetailView` to keep that file under the 500-line
 * ratchet, and it earns its own file: the counted tabs and the feature-gated one are a small rule
 * of their own, testable without mounting the panel.
 */
export const buildDetailViewTabs = ({
	t,
	isDeepResearchActive,
	researchCount,
	profilesCount,
}: DetailViewTabsInput): LeadPanelTabItem<DetailViewTab>[] => [
	{ label: t("contacts.leadPanel.tabs.overview"), value: DetailViewTab.OVERVIEW },
	...(isDeepResearchActive
		? [
				{
					label: t("contacts.leadPanel.tabs.research"),
					value: DetailViewTab.RESEARCH,
					count: researchCount,
				},
			]
		: []),
	{ label: t("contacts.leadPanel.tabs.timeline"), value: DetailViewTab.TIMELINE },
	{
		label: t("contacts.leadPanel.tabs.profiles"),
		value: DetailViewTab.PROFILES,
		count: profilesCount,
	},
];
